


























































































































































































import { mapActions, mapGetters, mapState }     from 'vuex'
import { Vue, Component, Watch }          from 'vue-property-decorator'
import { isObject, formatDate, formatDateHoursMinutes, formatDateSinTime, format_phone_number }   from '@/utils/helpers'
import { Ability }                              from '@/types/Ability'
import _                                        from 'lodash'
import { Etat, getEtatSpecReclamation, TypeReclamation, TypeReponseReclamation }             from '@/types/Reclamation'
import  ErrorDisplay                            from '@/components/ErrorDisplay.vue'
import Back                                     from '@/components/Tools/Back.vue'
import { FontAwesomeIcon }                      from '@fortawesome/vue-fontawesome'
import { etat_avis }                            from '@/types/ReclamationOral'
import { CandidatStatut }                       from '@/types/Candidat'


@Component({
    components: {
        ErrorDisplay,
        Back,
        'font-awesome-icon': FontAwesomeIcon
    },
    computed: {
        ...mapGetters('reclamationPostConcours', ['reclamations_post_concours', 'reclamationSelect', 'loading', 'error', 'PCSelectReclassementOpen']),
        ...mapGetters('auth', ['authUser', 'can', 'cannot', 'isA', 'isNotA', 'user_session_id']),
        ...mapGetters('reclamationType', ['reclamationTypes']),
        ...mapState('auth', ['user', 'authUser', 'user_session_id'])

    },
    methods: {
        ...mapActions('postes', ['getAllPostes'])
    }
})

export default class ReclamationPostGestion extends Vue {
    Ability                              = Ability
    CandidatStatut                       = CandidatStatut
    reclamationSelectLocal: any          = {}
    etat_reclamation_select: any         = {}
    etat_avancement                      = Etat.ETAT_NON_TRAITE
    lockInput                            = false
    Etat                                 = Etat
    erreur_manqueNote: any               = null
    affichageChat: any                   = []
    connected_user                       = this.$store.state.auth.user
    showModalDemandeAvis                 = false
    examinateur: any                     = null
    centre: any                          = null
    formatDateHoursMinutes               = formatDateHoursMinutes
    formatDateSinTime                    = formatDateSinTime
    etat_avis                            = etat_avis
    open_avis: any                       = null
    new_message                          = ''
    concour_id: any                      = ''
    savNoteDepart: any                   = ''
    noteChangeeNonEnregistree: any       = false
    index_reclamation: any = null
    max_index: any = null
    lock_button = false

    formatPhoneNumber = format_phone_number

    reclamation_type_id = null

    reclamationTypesTemps: Array<any> = []

    @Watch('reclamationSelectLocal.decision')
    @Watch('etat_avancement')
    etatAvancementChangeHandler() {
        // console.log('--- etat_avancement : ' + this.etat_avancement)
        this.reclamationTypesTemps = this.$store.state.reclamationType.reclamationTypes
        if (this.etat_avancement === Etat.ETAT_REJETEE) {
            this.reclamationTypesTemps  = this.reclamationTypesTemps.filter((r: any) => r.type_reponse === TypeReponseReclamation.TYPE_REPONSE_REJETEE)
        } else if (this.etat_avancement === Etat.ETAT_TRAITE) {
            if (this.reclamationSelectLocal.decision) {
                this.reclamationTypesTemps  = this.reclamationTypesTemps.filter((r: any) => r.type_reponse === TypeReponseReclamation.TYPE_REPONSE_ACCEPTEE)
            } else {
                this.reclamationTypesTemps  = this.reclamationTypesTemps.filter((r: any) => r.type_reponse === TypeReponseReclamation.TYPE_REPONSE_REFUSEE)
            }
        }
        if (this.reclamationTypesTemps.length === 1) {
            this.reclamation_type_id = this.reclamationTypesTemps[0].id
        }
    }

    getLoadingGLobal () {
        return this.$store.state.ensemble.loading || this.$store.state.reclamationPostConcours.loading || this.$store.state.reclamationType.loading
    }


    @Watch('user_session_id')
    retourMainPage () {
        this.$router.push('/reclamations_post_concours').catch(() => { console.log('catch redundant navigation reclamations_post_concours') })
    }


    @Watch('reclamationSelect')
    watchReclamationPost() {
        this.reclamationSelectLocal = {}
        this.etat_avancement = Etat.ETAT_NON_TRAITE

        if (this.$store.state.ensemble.ensembles.length === 0) {
            this.$store.dispatch('ensemble/getEnsembles').then(() => {
                this.watchReclamationPostSuite()
            })
        } else {
            this.watchReclamationPostSuite()
        }
    }

    watchReclamationPostSuite() {
        this.reclamationSelectLocal = _.cloneDeep(this.$store.getters['reclamationPostConcours/reclamationSelect'])
        this.initInterface()
        this.getEtatAvancementReclamation()
        this.concour_id = this.reclamationSelectLocal.candidat.resultats[1].concour_id
        this.setCollectionReclamations()
    }

    @Watch('index_reclamation')
    changeReclamationATraiter () {
        if (this.index_reclamation !== null && this.index_reclamation !== -1) {
            this.lock_button = true
            const id_reclam = this.$store.state.reclamationPostConcours.reclamations_post_concours[this.index_reclamation].id
            if (id_reclam.toString() !== this.$route.params.reclamation_id) {
                this.$router.push('/reclamations_post_concours/' + id_reclam).catch(() => { console.log('catch redundant navigation reclamations_post_concours/' + id_reclam) })
            }
            this.$store.dispatch('reclamationPostConcours/getReclamation', Number(id_reclam)).then(() => {
                this.initInterface()
                this.getEtatAvancementReclamation()
                this.lock_button = false
            })
        }
    }

    @Watch('reclamationSelectLocal.decision')
    changeRectifierNote() {
        if (!this.reclamationSelectLocal.decision) {
            // réinit des états et données d'interface correspondant à une rectification de note.
            this.reclamationSelectLocal.note = null
            this.noteChangeeNonEnregistree = false
        } else {
            /** on coche l'option de rectification de la note. On repasse l'état à "Réclamation non traitée", car la définition d'une note va impliquer un reclassement,
             * et on ne doit pas permettre d'être en état "traité" avec une rectification sans reclassement fait */
            this.etat_avancement = Etat.ETAT_NON_TRAITE
            if (this.$store.getters['reclamationPostConcours/PCSelectReclassementOpen'] && !this.reclamationSelectLocal.note) {
                this.noteChangeeNonEnregistree = true // permet de rendre cohérent l'affichage en fonction de ce contexte
            }
        }
    }

    @Watch('etat_avancement')
    changeEtat_avancement() {
        if (this.etat_avancement === Etat.ETAT_NON_TRAITE) {
            this.lockInput = false
        }
        if (!this.$store.getters['auth/can'](Ability.ORAL_RECLAM_MANAGE)) {
            this.lockInput = true
        }
    }

    @Watch('user_session_id')
    refreshInterface () {
        this.load()
    }

    @Watch('meta')
    refreshCollec () {
        this.setCollectionReclamations()
    }

    // Gére le remplissage de la collection et la récupération des index
    setCollectionReclamations () {
        // Gestion de la collection
        if (this.$store.state.reclamationPostConcours.reclamations_post_concours.length === 0) {
            const params = {}
            Vue.set(params, 'filter-type', TypeReclamation.TYPE_NOTE_ORAL)
            this.$store.dispatch('reclamationPostConcours/getReclamations', { filters : params }).then(() => {
                this.setMoreCollectionReclamations()
            })
        } else {
            this.setMoreCollectionReclamations()
        }
    }

    setMoreCollectionReclamations () {
        if (this.$store.state.reclamationPostConcours.meta && this.$store.state.reclamationPostConcours.reclamations_post_concours.length !== this.$store.state.reclamationPostConcours.meta.total) {
            while (this.$store.state.reclamationPostConcours.currentPage < this.$store.state.reclamationPostConcours.lastPage) {
                this.$store.state.reclamationPostConcours.currentPage++
                const params = {}
                Vue.set(params, 'filter-type', TypeReclamation.TYPE_NOTE_ORAL)
                Vue.set(params, 'page', this.$store.state.reclamationPostConcours.currentPage)
                this.$store.dispatch('reclamationPostConcours/getMoreReclamations', { filters : params }).then(() => {
                    // Récupère l'index de la réclamation ouverte
                    this.index_reclamation = this.$store.state.reclamationPostConcours.reclamations_post_concours.findIndex((rp: any) => rp.id === this.reclamationSelectLocal.id)
                    this.max_index = this.$store.state.reclamationPostConcours.reclamations_post_concours.length - 1
                })
            }
        } else {
            // Récupère l'index de la réclamation ouverte
            this.index_reclamation = this.$store.state.reclamationPostConcours.reclamations_post_concours.findIndex((rp: any) => rp.id === this.reclamationSelectLocal.id)
            this.max_index = this.$store.state.reclamationPostConcours.reclamations_post_concours.length - 1
        }
    }

    wNote() {
        this.noteChangeeNonEnregistree = true
    }


    /** Initialisation des datas */
    initInterface () {
        this.erreur_manqueNote = null
        if (this.reclamationSelectLocal.submitted_at) {
            this.lockInput = true
        } else {
            this.lockInput = false
        }
        if (!this.$store.getters['auth/can'](Ability.ORAL_RECLAM_MANAGE)) {
            this.lockInput = true
        }

        // Récupération du nom de l'examinateur
        if (this.reclamationSelectLocal.seance && this.reclamationSelectLocal.seance.creneau) {
            const ensemble = this.$store.state.ensemble.ensembles.find((e: any) => e.id === this.reclamationSelectLocal.seance.creneau.ensemble_id)
            this.examinateur = ensemble.examinateurs.find((ex: any) => ex.id === this.reclamationSelectLocal.seance.creneau.user_id)
            if (!this.examinateur) {
                this.examinateur = ensemble.remplacants.find((ex: any) => ex.id === this.reclamationSelectLocal.seance.creneau.user_id)
            }

            this.centre = this.reclamationSelectLocal.seance.creneau.ensemble.centre
        }
        if (this.reclamationSelectLocal && this.reclamationSelectLocal.submitted_at && !this.reclamationSelectLocal.validated_at) {
            this.etat_avancement = Etat.ETAT_TRAITE
        } else if (this.reclamationSelectLocal && this.reclamationSelectLocal.submitted_at && this.reclamationSelectLocal.validated_at) {
            this.etat_avancement = Etat.ETAT_SIGNE
        }

        // conversion des valeurs de reclamationSelectLocal.decision en pur boolean pour les tests d'état pour affichage de l'interface
        if (this.reclamationSelectLocal.decision === 1 || this.reclamationSelectLocal.decision === true) {
            this.reclamationSelectLocal.decision = true
        } else {
            this.reclamationSelectLocal.decision = false
        }


        this.getEtatAvancementReclamation()
    }

    /** Check si la value est un objet */
    isObjectLocal (value: any) {
        return isObject(value)
    }

    /** Formattage de date */
    formatteDate (date: Date) {
        return formatDate(date)
    }

    /** récupère la couleur d'état d'avancement du traitement de la réclamation  */
    getEtatAvancementReclamation() {
        let etat_final = Etat.ETAT_NON_TRAITE
        if (!this.reclamationSelectLocal.submitted_at && !this.reclamationSelectLocal.validated_at) {
            if (this.reclamationSelectLocal.message_gestionnaire || this.reclamationSelectLocal.note) {
                // Le traitement à commencer, mais n'est pas terminé
                etat_final = Etat.ETAT_EN_COURS
            } else {
                etat_final = Etat.ETAT_NON_TRAITE
            }
        }
        if (this.reclamationSelectLocal.submitted_at && !this.reclamationSelectLocal.validated_at) {
            etat_final = Etat.ETAT_TRAITE
        }
        if (this.reclamationSelectLocal.submitted_at && this.reclamationSelectLocal.validated_at) {
            etat_final = Etat.ETAT_SIGNE
        }
        if (this.reclamationSelectLocal.rejected_at) {
            etat_final = Etat.ETAT_REJETEE
        }
        this.reclamation_type_id = this.reclamationSelectLocal && this.reclamationSelectLocal.reclamationType ? this.reclamationSelectLocal.reclamationType.id : null
        this.etat_reclamation_select = getEtatSpecReclamation(etat_final)
        return etat_final
    }

    /** Retourne la liste passée en paramètre ordonnée par name */
    orderedListe (liste: any) {
        return _.orderBy(liste, 'name', 'asc')
    }


    /** gère un contrôle de la validité de la saisie de la réclamation avant de l'enregistrer */
    controleSaveReclamation () {
        this.erreur_manqueNote = null
        if (this.reclamationSelectLocal.decision && !this.reclamationSelectLocal.note) {
            this.erreur_manqueNote = 'La note rectifiée n\'est pas valable.'
        } else {
            // on lance l'enregistrement de la réclamation si pas d'erreur sur sa validité
            this.saveReclamation()
        }
    }

    /**
     * Enregistrement de la réclamation
     */
    saveReclamation () {
        const idInfo = 't_info_' + Math.random()
        const infosToaster = {
            id: idInfo,
            toaster: 'b-toaster-top-right',
            variant: 'primary',
            noCloseButton: true,
            fade: true,
            noAutoHide: true
        }

        const params = {
            reclamation_id: this.reclamationSelectLocal.id,
            type: TypeReclamation.TYPE_NOTE_ORAL,
            payload: {
                message_gestionnaire:    this.reclamationSelectLocal.message_gestionnaire,
                note:                    this.reclamationSelectLocal.decision ? this.reclamationSelectLocal.note : null,
                submit:                  this.etat_avancement,
                decision:                this.reclamationSelectLocal.decision ? 1 : 0,
                reclamation_type_id: this.reclamation_type_id
            }
        }
        this.$bvToast.toast('Enregistrement en cours...', infosToaster)
        this.$store.dispatch('reclamationPostConcours/updateReclamation', params).then(() => {
            this.$bvToast.hide(idInfo)
            const idSucces = 't_succes_' + Math.random()
            const succesToaster = {
                id: idSucces,
                toaster: 'b-toaster-top-right',
                variant: 'success',
                noCloseButton: true,
                fade: true,
                autoHideDelay: 5000
            }
            this.$bvToast.toast('Enregistrement terminé', succesToaster)
            this.noteChangeeNonEnregistree = false
        }).catch(() => {
            this.$bvToast.hide(idInfo)
        })
    }


    /** push vers la page des reclassements, transmet l'id de la reclamation et l'id du candidat  */
    reclassementRoute() {
        const findConcourId = this.reclamationSelectLocal.candidat.resultats[1].concour_id
        this.$store.commit('reclassement/SET_RECLASSEMENT_CANDIDAT_SELECT', this.reclamationSelectLocal)
        this.$router.push({ path: `/reclamations_post_concours/${this.reclamationSelectLocal.id}/reclassement/${this.reclamationSelectLocal.candidat.id}/concours/${findConcourId}` }).catch(() => { console.log('catch redundant navigation ' + `/reclamations_post_concours/${this.reclamationSelectLocal.id}/reclassement/${this.reclamationSelectLocal.candidat.id}/concours/${findConcourId}`) })
    }

    /**
     * Aperçu de la fiche orale du candidat
     */
    voirFicheOral (item: any)
    {
        if (item && item.id !== undefined)
        {
            window.open(this.$store.getters['candidat/getCorrectionOnViatique'](item.id), '_blank')
        }
    }

    load () {
        this.reclamationSelectLocal = _.cloneDeep(this.$store.getters['reclamationPostConcours/reclamationSelect'])
        this.initInterface()
        this.getEtatAvancementReclamation()
    }

    mountedSuite() {
        this.$store.dispatch('reclamationType/getReclamationTypes').then(() => {
            this.$store.dispatch('reclamationPostConcours/getReclamation', Number(this.$route.params.reclamation_id)).then(() => {
                this.load()
            })
        })
    }

    mounted() {
        if (this.$store.getters['auth/user_session_id'] !== null) {
            if (this.$store.state.ensemble.ensembles.length === 0) {
                this.$store.dispatch('ensemble/getEnsembles').then(() => {
                    this.mountedSuite()
                })
            } else {
                this.mountedSuite()
            }
        }
    }

    beforeMount() {
        this.connected_user = this.$store.state.auth.user
    }
}

